import { createSelector } from "@reduxjs/toolkit";

export const selectIsProposalLoading = (state) =>
  state?.proposals?.proposal?.isLoading;

export const selectProposal = (state) => state?.proposals?.proposal?.data;

export const selectIsProposalArchived = (state) =>
  Boolean(state?.proposals?.proposal?.data?.archivedAt);

export const selectProposalTitle = createSelector(
  [selectProposal],
  (proposal) => proposal?.title
);

export const selectProposalId = createSelector(
  [selectProposal],
  (proposal) => proposal?.id
);

export const selectHasProposalOutline = createSelector(
  [selectProposal],
  (proposal) => Boolean(proposal?.hasProposalOutline)
);

export const selectShowEditPanel = (state) =>
  state?.proposals?.proposal?.showEditPanel;

export const selectEditingProposal = (state) =>
  state?.proposals?.proposal?.editingProposal;
